module.exports = __webpack_public_path__ + "img/T2D_rc_15.d38453d7.png";